import { connect } from "react-redux";
import QuanLyCongViec from "components/QuanLyCongViec";
import { getListQuanLyCongViec } from "actions/QuanLyCongViec";

const mapStateToProps = (state) => ({
  quanlycongviec: state.quanlycongviec,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListQuanLyCongViec: (dataSearch) =>
    dispatch(getListQuanLyCongViec(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(QuanLyCongViec);
